/*
 * ===== assets/product-card.js =====
 * 商品卡片選色小圓點互動控制器
 */

(function () {
  'use strict';

  function initProductCards() {
    var cards = document.querySelectorAll('[data-product-card]');
    
    cards.forEach(function (card) {
      if (card.classList.contains('is-initialized')) return;
      card.classList.add('is-initialized');

      var mainImg = card.querySelector('[data-card-main-image]');
      if (!mainImg) return;

      var originalSrc = mainImg.src;
      var activeSrc = originalSrc;
      
      var dots = card.querySelectorAll('[data-color-name]');
      var idInput = card.querySelector('[data-variant-id-input]');
      var atcBtn = card.querySelector('[data-card-atc-btn]');
      var atcText = card.querySelector('[data-atc-text]');
      var priceDisplay = card.querySelector('[data-card-price-display]');

      // 滑鼠移出整張卡片時，還原為當前選中（或最初）的圖片
      card.addEventListener('mouseleave', function () {
        mainImg.src = activeSrc;
      });

      dots.forEach(function (dot) {
        // Hover 預覽圖片
        dot.addEventListener('mouseenter', function () {
          var hoverImg = dot.getAttribute('data-variant-image');
          if (hoverImg) {
            mainImg.src = hoverImg;
          }
        });

        // 點擊選取變體
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          // 切換選中樣式
          dots.forEach(function (d) { d.classList.remove('is-selected'); });
          dot.classList.add('is-selected');

          // 更新預設圖片快取，當滑鼠離開時維持在選取色
          var selectedImg = dot.getAttribute('data-variant-image');
          if (selectedImg) {
            activeSrc = selectedImg;
            mainImg.src = selectedImg;
          }

          // 更新 Form 的 Variant ID
          var variantId = dot.getAttribute('data-variant-id');
          if (idInput) {
            idInput.value = variantId;
          }

          // 更新價格顯示
          var variantPrice = dot.getAttribute('data-variant-price');
          if (priceDisplay && variantPrice) {
            priceDisplay.textContent = variantPrice;
          }

          // 更新按鈕庫存狀態
          var isAvailable = dot.getAttribute('data-variant-available') === 'true';
          if (atcBtn) {
            atcBtn.disabled = !isAvailable;
            if (atcText) {
              if (isAvailable) {
                var lang = document.documentElement.lang || 'zh-TW';
                var defaultText = lang.indexOf('zh') > -1 ? '加入購物車' : 'Add to Cart';
                atcText.textContent = defaultText;
              } else {
                var lang = document.documentElement.lang || 'zh-TW';
                var defaultText = lang.indexOf('zh') > -1 ? '已售完' : 'Sold Out';
                atcText.textContent = defaultText;
              }
            }
          }
        });
      });
    });
  }

  // 頁面加載完成初始化
  document.addEventListener('DOMContentLoaded', initProductCards);
  
  // 當 AJAX 加載更多商品後（如 Collection Load More），重新觸發初始化
  document.addEventListener('bh-cards:inserted', initProductCards);

  // 暴露全域 API 供 AJAX 載入腳本時手動觸發
  window.initProductCards = initProductCards;

})();
